// 지사 유치원 관리
export const CREATE_KINDER = 'CREATE_KINDER'    // create kinder Id
export const ADD_KINDER = 'ADD_KINDER'
export const UPDATE_KINDER = 'UPDATE_KINDER'
export const DELETE_KINDER = 'DELETE_KINDER'

// 지사 유치원의 반 관리
export const CREATE_KINDER_CLASS = 'CREATE_KINDER_CLASS'
export const ADD_CLASS = 'ADD_CLASS'
export const UPDATE_KINDER_CLASS = 'UPDATE_KINDER_CLASS'
export const DELETE_KINDER_CLASS = 'DELETE_KINDER_CLASS'



//유치원 DB로 전달할 때
export const COMPLETE_ADD_KINDER = 'COMPLETE_ADD_KINDER'
export const EDITING_KINDER = 'EDITING_KINDER'

//User 정보 수정
export const EDITING_USER = 'EDITING_USER'
export const UPDATE_USER = 'UPDATE_USER'
export const EDITED_USER = 'EDITED_USER'

export const REQUEST_REFUND_BY_USER = 'REQUEST_REFUND_BY_USER'
export const REFUND_REQUEST = 'REFUND_REQUEST'
export const REFUND_FAILURE = 'REFUND_FAILURE'



// WEBPACK FOOTER //
// ./src/UserAccount/constants/types.js